// ABOUTME: Inline loading spinner for buttons and small areas
// ABOUTME: Conditionally renders based on loading prop

import * as React from "react"
import { cn } from "@shared/lib/utils"
import { SpinnerIcon } from "./SpinnerIcon"
import { sizeClasses, colorClasses, type SpinnerColor, type SpinnerSize } from "./spinnerClasses"

interface CSpinnerInlineProps {
  loading?: boolean
  className?: string
  size?: SpinnerSize
  color?: SpinnerColor
}

export const CSpinnerInline: React.FC<CSpinnerInlineProps> = ({ loading, className, size = "sm", color = "info" }) => {
  if (!loading) {
    return null
  }

  const classWrap = className ?? "absolute top-8 right-1/2"

  return <SpinnerIcon className={cn(sizeClasses[size], colorClasses[color], classWrap)} />
}
